module.exports = __webpack_public_path__ + "static/media/6530.f87f5dba.jpg";